import { render } from "./CasinoPage.vue?vue&type=template&id=2406652b&scoped=true"
import script from "./CasinoPage.vue?vue&type=script&lang=js"
export * from "./CasinoPage.vue?vue&type=script&lang=js"

import "./CasinoPage.vue?vue&type=style&index=0&id=2406652b&scoped=true&lang=css"

import exportComponent from "/Users/derem1991/workspace/newear/frontend/kajot/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2406652b"]])

export default __exports__